import {
  FileContentType,
  FileType,
  IFileRefGetBaseName,
  IFileRefGetCleanPath,
  IFileReference,
  IFileRefIsLocal
} from '@summit/core';
import { EboObject } from '../../base-classes/ebo-object';
import { Company } from './company';

export class CompanyFile extends EboObject implements IFileReference {
  companyId: string;
  company: Company;
  name: string;
  path: string;
  blobPath: string; // Required for dynamic file loading
  order: number;
  fileType: FileType;
  contentType: FileContentType;

  constructor(jsonData: Partial<CompanyFile>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.company) this.company = new Company(jsonData.company);
    }
    this.contentType ??= FileContentType.Attachment;
  }

  get baseName(): string {
    return IFileRefGetBaseName(this);
  }
  get cleanPath(): string {
    return IFileRefGetCleanPath(this);
  }
  get isLocal(): boolean {
    return IFileRefIsLocal(this);
  }
}
